import { CfFooterSchema, FooterSchema, footerSchema } from "../schema";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { assert } from "superstruct";
import { convertJsonAnchorToPolyAnchor } from "components/Anchor/utils";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { useSiteContext } from "context/SiteProvider";
import Footer, { Props as FooterProps } from "components/Footer";
import React from "react";
import parse from "html-react-parser";

const CfFooter = ({ dataJson, identifiers }: CfFooterSchema) => {
  const { dispatch } = useSiteContext();
  try {
    assert(dataJson, footerSchema);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  const liveDataJson = useContentfulLiveUpdates({
    ...dataJson,
    ...identifiers,
    sys: { id: identifiers.contentful_id },
  });

  const {
    top: {
      left: { apps },
      center,
      right: { social },
    },
    bottom: { logo, disclaimer, manageCookies },
  } =
    "configuration" in liveDataJson
      ? (liveDataJson.configuration as FooterSchema)
      : liveDataJson;

  const liveInspector: LiveInspectorData = {
    footer: ContentfulLivePreview.getProps({
      entryId: identifiers.contentful_id,
      fieldId: "configuration",
    }),
  };

  const props: FooterProps = {
    apps,
    center: center.map(({ title, list }) => ({
      title,
      list: list.map(({ label, ...anchorProps }) => ({
        label,
        ...convertJsonAnchorToPolyAnchor(anchorProps),
      })),
    })),
    social,
    logo,
    disclaimer: parse(disclaimer),
    manageCookies,
    onManageCookiesClick: () =>
      dispatch?.({ type: "write_script_gtm", payload: false }),
  };

  return (
    <div {...liveInspector?.footer}>
      <Footer {...props} />
    </div>
  );
};

export default CfFooter;
